import { stock } from '@/data/stockImages';

// Hesap (C). Hedef: kafede ürün maliyeti nasıl hesaplanır, restoranda yemek maliyeti hesaplama, food cost.
export default [
  {
    t: 'p',
    text: 'Bir ürünün maliyeti, onu hazırlarken kullandığınız her malzemenin miktarı ile birim alış fiyatının çarpılıp toplanmasıyla bulunur. Formül basittir: **ürün maliyeti = Σ (reçetedeki miktar × birim fiyat)**. Hesabın zor kısmı, doğru miktarı ve güncel fiyatı bilmektir. Bu yazıda bir kafe içeceği ve bir restoran yemeği üzerinden hesabı adım adım yapıyoruz.',
  },
  { t: 'h2', text: 'Hesap için gerekenler' },
  {
    t: 'list',
    items: [
      '**Reçete:** Ürünün içine giren her malzeme ve tartılarak ya da ölçülerek belirlenmiş miktarı.',
      '**Birim fiyat:** Malzemenin gram, mililitre ya da adet başına alış fiyatı. 1 kg kahve 1.200 TL ise gramı 1,20 TL’dir.',
      '**Kullanılabilir oran:** Temizlendiğinde ağırlık kaybeden malzemelerde (et, balık, sebze) satın alınan ağırlığın ne kadarının tabağa girdiği.',
    ],
  },
  { t: 'h2', text: 'Örnek 1: Bir latte’nin maliyeti' },
  {
    t: 'img',
    img: stock('latte', 'Latte art ile servis edilen bir fincan latte'),
  },
  {
    t: 'p',
    text: 'Bir latte için 18 g kahve çekirdeği ve 200 ml süt kullanıldığını varsayalım. Kahvenin kilosu 1.200 TL, sütün litresi 45 TL olsun.',
  },
  {
    t: 'table',
    head: ['Malzeme', 'Miktar', 'Birim fiyat', 'Tutar'],
    rows: [
      ['Kahve çekirdeği', '18 g', '1,20 TL/g', '21,60 TL'],
      ['Süt', '200 ml', '0,045 TL/ml', '9,00 TL'],
      ['**Toplam hammadde**', '', '', '**30,60 TL**'],
    ],
    caption: 'Fiyatlar örnek amaçlıdır; kendi alış fiyatlarınızla hesaplayın.',
  },
  {
    t: 'p',
    text: 'Aynı latte paket servis ediliyorsa karton bardak ve kapak da maliyete girer. Bunların adedi 6 TL ise paket latte’nin maliyeti 36,60 TL olur. Salonda ve pakette farklı maliyet çıkması normaldir; fiyatlandırmada bu farkı hesaba katmak gerekir.',
  },
  { t: 'h2', text: 'Örnek 2: Bir yemeğin maliyeti' },
  {
    t: 'p',
    text: 'Restoran yemeklerinde kalem sayısı artar ve kullanılabilir oran devreye girer. Bir ızgara somon tabağında 200 g temizlenmiş somon, 25 TL’lik sebze garnitürü ve 8 TL’lik zeytinyağı, limon ve baharat olduğunu varsayalım. Somon filetonun kilosu 900 TL, temizlendikten sonra ağırlığın %90’ı kullanılabiliyor.',
  },
  {
    t: 'p',
    text: 'Kullanılabilir oranı hesaba katmak için birim fiyatı bu orana bölmek gerekir: 900 ÷ 0,90 = kullanılabilir kilosu 1.000 TL. Bu durumda 200 g somonun maliyeti 180 TL değil, 200 TL olur.',
  },
  {
    t: 'table',
    head: ['Malzeme', 'Oran dahil değil', 'Oran dahil'],
    rows: [
      ['Somon (200 g)', '180 TL', '200 TL'],
      ['Sebze garnitürü', '25 TL', '25 TL'],
      ['Zeytinyağı, limon, baharat', '8 TL', '8 TL'],
      ['**Toplam**', '**213 TL**', '**233 TL**'],
    ],
  },
  {
    t: 'p',
    text: 'Aradaki 20 TL, tabak başına görünmeyen bir maliyettir. Ayda yüz tabak satılan bir yemekte bu fark 2.000 TL eder. Et ve balık ağırlıklı menülerde kullanılabilir oranı atlamak, maliyeti sistematik olarak düşük gösterir.',
  },
  { t: 'h2', text: 'Maliyet oranı (food cost) nasıl hesaplanır?' },
  {
    t: 'p',
    text: 'Maliyet oranı, ürün maliyetinin KDV hariç satış fiyatına bölünmesiyle bulunur: **maliyet oranı = ürün maliyeti ÷ KDV hariç satış fiyatı**. KDV hariç fiyatı kullanmak önemlidir, çünkü KDV işletmenin geliri değildir.',
  },
  {
    t: 'table',
    head: ['Ürün', 'Maliyet', 'Satış (KDV dahil)', 'Satış (KDV hariç)', 'Maliyet oranı'],
    rows: [
      ['Latte (salon)', '30,60 TL', '150 TL', '136,36 TL', '%22,4'],
      ['Latte (paket)', '36,60 TL', '150 TL', '136,36 TL', '%26,8'],
      ['Izgara somon', '233 TL', '750 TL', '681,82 TL', '%34,2'],
    ],
    caption: 'Örnekte KDV oranı %10 alınmıştır. Ürününüze uygulanan güncel oranı mali müşavirinizle teyit edin.',
  },
  {
    t: 'p',
    text: 'Kafe ve restoranlarda hedeflenen maliyet oranı çoğunlukla %25–35 aralığında konuşulur. Ancak bu tek başına bir ölçüt değildir: içeceklerde oran genellikle daha düşük, et ve balık yemeklerinde daha yüksek çıkar. Önemli olan her ürünün oranını bilmek ve menünün genelinde dengeyi korumaktır. Maliyet oranından satış fiyatına nasıl gidileceğini [kafe menü fiyatları nasıl belirlenir](/blog/kafe-menu-fiyatlari-nasil-belirlenir) yazısında anlattık.',
  },
  { t: 'h2', text: 'Alış fiyatı değişince maliyet nasıl güncellenir?' },
  {
    t: 'p',
    text: 'Aynı malzemeyi farklı zamanlarda farklı fiyatlardan alırsınız. Maliyet hesabında hangi fiyatın kullanılacağı iki şekilde belirlenir:',
  },
  {
    t: 'list',
    items: [
      '**Önce giren önce çıkar (FIFO):** Elinizdeki en eski partinin fiyatı kullanılır; o parti bittiğinde bir sonrakine geçilir. Rafta gerçekte olan duruma en yakın hesaptır.',
      '**Ağırlıklı ortalama:** Eldeki tüm partilerin fiyatları miktarlarıyla ağırlıklandırılarak ortalaması alınır. Örneğin 5 litre 40 TL’den ve 20 litre 50 TL’den süt varsa ortalama litre fiyatı 48 TL olur.',
    ],
  },
  {
    t: 'p',
    text: 'Elle yapılan hesaplarda fiyat genellikle bir kez girilir ve aylarca güncellenmez. Enflasyonun yüksek olduğu dönemlerde bu, maliyetin olduğundan düşük görünmesine yol açar. Stok girişinde alış fiyatının kaydedilmesi, hesabın kendiliğinden güncel kalmasını sağlar; ayrıntısı [stok takibi](/blog/stok-takibi-nasil-yapilir) yazısında.',
  },
  { t: 'h2', text: 'Hammadde dışındaki maliyetler' },
  {
    t: 'p',
    text: 'Ürün maliyeti genellikle yalnızca hammaddeyi kapsar. Kira, personel ve faturalar gibi giderler işletme genelinde hesaplanır ve fiyatlandırmada ayrıca dikkate alınır. Bunun dışında bazı giderler doğrudan ürüne bağlıdır: paket ambalajı, peçete ve ıslak mendil, bazı işletmelerde ürüne özel işçilik. Bunları ürün maliyetine ek kalem olarak eklemek, özellikle paket satışta daha gerçekçi bir tablo verir.',
  },
  { t: 'h2', text: 'Tilki Otomasyon’da ürün maliyeti' },
  {
    t: 'p',
    text: 'Tilki’de stok ekranındaki “Maliyet” sekmesinde bir ürün seçtiğinizde reçetesindeki her malzemenin tutarı ve toplam hammadde maliyeti görünür. Hesap, stok girişinde kaydettiğiniz alış fiyatlarıyla ve önce giren partiden yapılır; ağırlıklı ortalamaya göre tutar da yanında gösterilir. Ambalaj ya da işçilik gibi giderleri ek maliyet kalemi olarak ekleyip güncel toplam maliyeti görebilirsiniz.',
  },
  {
    t: 'cta',
    title: 'Ürünlerinizin maliyetini görün',
    text: 'Ücretsiz demo talep edin; birkaç ürününüzün reçetesini girip maliyetini birlikte hesaplayalım.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Ürün maliyetine kira ve personel gideri dahil edilir mi?',
    a: 'Genellikle hayır. Ürün maliyeti hammadde ve ürüne doğrudan bağlı giderlerden (ambalaj gibi) oluşur. Kira, personel ve faturalar sabit gider olarak ayrıca hesaplanır ve fiyatlandırmada kâr payının karşılaması gereken tutar olarak dikkate alınır.',
  },
  {
    q: 'Maliyet oranı yüksek çıkan ürünü menüden çıkarmalı mıyım?',
    a: 'Hemen değil. Yüksek oranlı bir ürün çok satıyor ve tabak başına iyi bir tutar bırakıyorsa menüde kalmaya değer. Karar verirken oranın yanında satış adedine ve ürün başına kalan tutara da bakmak gerekir.',
  },
  {
    q: 'Reçetedeki miktarları nasıl belirlerim?',
    a: 'Ürünü birkaç kez hazırlarken malzemeleri tartarak ve ölçerek. Personelin gerçekte kullandığı miktarla reçetedeki miktar farklıysa, önce hazırlık standardını belirlemek ve reçeteyi buna göre yazmak gerekir.',
  },
];
